import React from 'react'
import { connect } from 'react-redux'

class Declaration extends React.Component {
  render() {
    return (
      <div className='card card-single'>
        <div className='card-header'>
          <div className='pull-right'>
            <a className='smaller' href='#' onClick={ () => this.props.onGoToClick('declarations')}>Edit</a>
          </div>
          Declarations
        </div>
        <div className='card-body'>
          {this.props.declarations.map((declaration) => {
            return (
              <div className='big mb-3'>{declaration}</div>
            )
            })
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  declarations: state.review.declarations,
})

export default connect(mapStateToProps, {
})(Declaration)
